import { Node_Type } from 'ricos-types';
import { TOOLBARS, INSERT_PLUGIN_BUTTONS, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { INSERT_POLL_MODAL_ID } from './consts.js';
import { InsertPluginIcon } from './assets/icons/InsertPluginIcon.js';
import { InsertModal } from './components/insert-modal/insert-modal.js';
import 'ricos-schema';
import 'react';
import '@wix/design-system';
import 'ricos-context';
import 'wix-rich-content-ui-components';
import './dataHooks.js';
import './types.js';
import './components/insert-modal/preset-data.js';
import 'lodash';
import './defaults.js';
import './helpers.js';
import 'ricos-schema/next';
import 'wix-rich-content-common/libs/imageUtils';
import './components/insert-modal/preset-picker.js';
import './style-inject.es-e7b07dd7.js';
import './assets/icons/ListPollIcon.js';
import './assets/icons/WithImagePollIcon.js';
import './assets/icons/GridPollIcon.js';

const toolbarsToAddIn = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE
];
const getAddButtons = (config, services) => {
  return [
    {
      id: Node_Type.POLL,
      label: INSERT_PLUGIN_BUTTONS.POLLS,
      dataHook: INSERT_PLUGIN_BUTTONS.POLLS,
      icon: InsertPluginIcon,
      tooltip: "Poll_InsertPoll_Tooltip",
      toolbars: [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      command: () => true,
      modal: {
        id: INSERT_POLL_MODAL_ID,
        Component: decorateComponentWithProps(InsertModal, {
          config
        }),
        noPadding: true
      },
      menuConfig: {
        tags: "Poll_plugin_search_tags"
      }
    }
  ];
};

export { getAddButtons, toolbarsToAddIn };
//# sourceMappingURL=getAddButtons.js.map
